import { ref } from 'vue';

// A route's component is a dynamic import (every route in router.ts is lazy),
// resolved as part of router navigation itself, between beforeEach and
// afterEach. On a slow connection or a cold chunk cache that resolution can
// take multiple seconds, and Vue Router leaves the CURRENT view mounted the
// whole time (out-in transitions don't start until the incoming component is
// ready). With nothing else signaling that anything is happening, a slow
// chunk fetch reads as a frozen or blank page. This ref just needs to span
// that gap; router.ts flips it in beforeEach/afterEach/onError.
export const isNavigating = ref(false);
